import { render } from "./module-attachment.vue?vue&type=template&id=adc9b2bc"
import script from "./module-attachment.vue?vue&type=script&lang=js"
export * from "./module-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__